import {get,post} from '@/util/http';
import { Notification } from 'uiv'

const participation = {
    state:{
        faq: []
    },
    mutations:{
        faqList(state, action){
            state.faq = action
        }
    },
    actions:{
        async getContent({},params){//展厅平面图(图片)
            const res = await get('/CifitSystem/api/attendGuide/service.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getimgList({},params){//展厅平面图(图片)
            const res = await get('/CifitSystem/api/attendGuide/getList.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async parking({},params){//展区停车
            const res = await get('/CifitSystem/api/attendGuide/parking.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async reporterfaq({commit},params){//中文记者参展指南
            const res = await get('/CifitSystem/api/attendGuide/findMain2.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async faq({commit},params){//参会问答
            const res = await get('/CifitSystem/api/seminar/participationQNA/getList.jhtml',params);
            if(res.code == 200){
                commit('faqList', res.data);
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
    }
}

export default participation


// WEBPACK FOOTER //
// ./src/store/modules/participation.js